/* global axios */
import ApiClient from './ApiClient';
import { browserTimeZone } from 'dashboard/modules/tasks/helpers/dueDate';

class TasksAPI extends ApiClient {
  constructor() {
    super('tasks', { accountScoped: true });
  }

  // o servidor roda em UTC: os filtros de data ('YYYY-MM-DDT00:00:00') e as
  // abas Hoje/Atrasadas são interpretados no fuso de quem está usando
  list(params = {}) {
    return axios.get(this.url, {
      params: { time_zone: browserTimeZone(), ...params },
    });
  }

  show(taskId) {
    return axios.get(`${this.url}/${taskId}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(taskId, data) {
    return axios.patch(`${this.url}/${taskId}`, data);
  }

  destroy(taskId) {
    return axios.delete(`${this.url}/${taskId}`);
  }

  listComments(taskId) {
    return axios.get(`${this.url}/${taskId}/task_comments`);
  }

  createComment(taskId, content, files = []) {
    if (files.length > 0) {
      const formData = new FormData();
      formData.append('content', content);
      files.forEach(file => formData.append('files[]', file));
      return axios.post(`${this.url}/${taskId}/task_comments`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }
    return axios.post(`${this.url}/${taskId}/task_comments`, { content });
  }

  updateComment(taskId, commentId, payload) {
    return axios.patch(
      `${this.url}/${taskId}/task_comments/${commentId}`,
      payload
    );
  }

  destroyComment(taskId, commentId) {
    return axios.delete(`${this.url}/${taskId}/task_comments/${commentId}`);
  }

  listActivities(taskId) {
    return axios.get(`${this.url}/${taskId}/task_activities`);
  }

  revertActivity(taskId, activityId) {
    return axios.post(
      `${this.url}/${taskId}/task_activities/${activityId}/revert`
    );
  }

  bulkUpdate(ids, data) {
    return axios.patch(`${this.url}/bulk_update`, { ids, ...data });
  }

  bulkDestroy(ids) {
    return axios.delete(`${this.url}/bulk_destroy`, { data: { ids } });
  }

  bulkLabelAdd(ids, label) {
    return axios.patch(`${this.url}/bulk_update`, {
      ids,
      label_action: 'add',
      label,
    });
  }

  bulkLabelRemove(ids, label) {
    return axios.patch(`${this.url}/bulk_update`, {
      ids,
      label_action: 'remove',
      label,
    });
  }

  bulkLabelRemoveAll(ids) {
    return axios.patch(`${this.url}/bulk_update`, {
      ids,
      label_action: 'remove_all',
    });
  }
}

export default new TasksAPI();
